/*!
 * Ridge River Whiskey - Big Thirst Storefront Loader
 *
 * Install this stable file once on the WordPress site. It fetches the config
 * with a fresh query string so future config and engine changes do not require
 * another WordPress snippet edit.
 */

(function () {
  'use strict';

  if (window.__BT_RIDGE_RIVER_LOADER_LOADED) return;
  window.__BT_RIDGE_RIVER_LOADER_LOADED = true;

  var DEFAULT_CONFIG_SRC = 'https://checkout-6.bigthirst.com/cdn/shop/files/ridge-river-config.js';
  var configSrc = window.__BT_RIDGE_RIVER_CONFIG_SRC || DEFAULT_CONFIG_SRC;
  var configVersion = window.__BT_RIDGE_RIVER_CONFIG_VERSION || String(Date.now());
  var separator = configSrc.indexOf('?') === -1 ? '?' : '&';
  var head = document.head || document.documentElement;
  var script = document.createElement('script');

  script.src = configSrc + separator + 'v=' + encodeURIComponent(configVersion);
  script.async = false;
  script.setAttribute('data-bt-ridge-river-config', 'true');
  head.appendChild(script);
})();
